"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var version = '2.2.1';
exports.version = version;
//# sourceMappingURL=version.js.map